import { useRaceTrack } from '@utmb/contexts/RaceTrackContext';
import * as React from 'react';
import { FC } from 'react';

import styles from './race-profile3d.module.scss';
import { CookieCategorieEnum } from '@utmb/design-system/types/cookie-consent-helper';
import ConsentAware from '@utmb/design-system/consent/ConsentAware';

export const RaceProfile3D: FC = () => {
    const { url3d } = useRaceTrack();

    if (!url3d) return null;
    const consents: CookieCategorieEnum[] = [];
    if (url3d.includes('youtube')) {
        consents.push(CookieCategorieEnum.FUNCTIONNAL);
        consents.push(CookieCategorieEnum.TARGETING);
        //} else if (url3d.includes('dailymotion')) {
        //consents.push(CookieCategorieEnum.FUNCTIONNAL);
    } else if (url3d.includes('vimeo')) {
        consents.push(CookieCategorieEnum.FUNCTIONNAL);
    } else if (url3d.includes('facebook')) {
        consents.push(CookieCategorieEnum.FUNCTIONNAL);
        consents.push(CookieCategorieEnum.TARGETING);
        consents.push(CookieCategorieEnum.PERFORMANCE);
    } else if (url3d.includes('livestream')) {
        consents.push(CookieCategorieEnum.FUNCTIONNAL);
    }

    return (
        <div className={styles.iframe_wrapper}>
            <ConsentAware category={consents} aspectRatio="16/9">
                <iframe
                    src={url3d}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; "
                    frameBorder={0}
                    allowFullScreen={true}
                    title="Race Profile 3D"
                ></iframe>
            </ConsentAware>
        </div>
    );
};
